import { CSSProperties } from "react";

export default (settings: any, styles: any): any => {
    const style: CSSProperties = {};
    const classes: string[] = [];

    if (settings?.controlsColor) {
        style["--slideshow-controls-color"] = settings?.controlsColor;
    }

    if (settings?.paginationColor) {
        style["--slideshow-pagination-color"] = settings.paginationColor;
    }

    if (settings?.paginationActiveColor) {
        style["--slideshow-pagination-active-color"] = settings.paginationActiveColor;
    }

    return {
        containerStyles: style,
        containerClasses: classes.join(" ")
    };
};